
import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Table, Button, Input, FormGroup, Label, Card, CardBody, Col, Row, Container } from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import Select from 'react-select';
import { fetchDepartments } from "store/actions";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import TableContainer from "components/Common/TableContainer";

const SettlementTable = () => {
  const employeeData = [
    { id: 1, empCode: "004", name: "SURESH", category: "Admin", department: "Admin", relievedDate: "06.04.24" },
    { id: 2, empCode: "011", name: "RAMKI", category: "Staff", department: "PRODUCTION", relievedDate: "05.04.24" },
    { id: 3, empCode: "023", name: "DEVI", category: "Foreman", department: "Admin", relievedDate: "03.04.24" },
  ];

  const columns = [
    { Header: "Emp Code", accessor: "empCode" },
    { Header: "Name", accessor: "name" },
    { Header: "Category", accessor: "category" },
    { Header: "Department", accessor: "department" },
    { Header: "Relieved Date", accessor: "relievedDate" },
    {
      Header: "Settlement",
      accessor: "settlement",
      Cell: () => <a href="#">Settlement</a>,
    },
    {
      Header: "Certificate",
      accessor: "certificate",
      Cell: () => <span role="img" aria-label="certificate">🏅</span>,
    },
    {
      Header: "Confirmation",
      accessor: "confirmation",
      Cell: () => <a href="#">Confirmation</a>,
    },
    {
      Header: "Gratuity",
      accessor: "gratuity",
      Cell: () => <a href="#">Gratuity</a>,
    },
  ];




  const [showForm, setShowForm] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  const [authDetails, setAuthDetails] = useState(null);

  const dispatch = useDispatch()

  const { departments } = useSelector((state) => state.DepartmentMaster || {});

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchDepartments(unitId));
  }, [dispatch]);

  // select custome style
  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 33.1,
      minHeight: 33.1,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Payroll / Deduction" breadcrumbItem="Settlement" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* Filters */}
                  {!showForm ? (
                    <>
                      {/* Filters */}
                      <Row className="align-items-center mb-3">
                        <Col md={4}>
                          <FormGroup className="me-3" >
                            <Label for="department">Department</Label>
                            <Select
                              id="department"
                              options={departments}
                              value={selectedDepartment}
                              onChange={setSelectedDepartment}
                              placeholder="Select Department"
                              styles={SelectcustomStyles}
                            />
                          </FormGroup></Col>
                        <Col md={4}>
                          <FormGroup className="me-3">
                            <Label for="employeeCode">Employee Code</Label>
                            <Input type="text" id="employeeCode" />
                          </FormGroup></Col>
                        <Col md={4} className="text-end">
                          <Button type="submit" className="btn button-search me-2">
                            <i className="fas fa-search me-1" /> Search
                          </Button>
                          <Button onClick={() => setShowForm(true)} className="btn button-add me-2">
                            <i className="fas fa-plus me-1" />Create New
                          </Button>
                        </Col>
                      </Row>

                      {/* Table */}
                      <TableContainer columns={columns} data={employeeData} isGlobalFilter={true} customPageSize={10} className="custom-header-css" />


                      {/* <Table bordered>
                        <thead>
                          <tr>
                            <th>SNo</th>
                            <th>Emp Code</th>
                            <th>Employee Name</th>
                            <th>Category</th>
                            <th>Department</th>
                            <th>Relieved Date</th>
                            <th>SETTLEMENT</th>
                            <th>CERTIFICATE</th>
                            <th>CONFIRMATION</th>
                            <th>GRATUITY</th>
                          </tr>
                        </thead>
                        <tbody>
                          {employeeData.map((employee, index) => (
                            <tr key={employee.id}>
                              <td>{index + 1}</td>
                              <td>{employee.empCode}</td>
                              <td>{employee.name}</td>
                              <td>{employee.category}</td>
                              <td>{employee.department}</td>
                              <td>{employee.relievedDate}</td>
                              <td><a href="#">Settlement</a></td>
                              <td>🏅</td>
                              <td><a href="#">Confirmation</a></td>
                              <td><a href="#">Gratuity</a></td>
                            </tr>
                          ))}
                        </tbody>
                      </Table> */}
                    </>
                  ) : (
                    <>
                      {/* Settlement Form */}
                      <div className="border p-3">
                        <h5 className="bg-light p-2">SETTLEMENT EARNINGS DETAILS</h5>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Employee Details</Label>
                              <Input type="select">
                                <option>Select</option>
                              </Input>
                            </FormGroup>
                            <FormGroup>
                              <Label>Designation</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Grade</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Date of Birth</Label>
                              <Input type="date" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Date of Join</Label>
                              <Input type="date" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Date of Resignation</Label>
                              <Input type="date" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Date of Relieving</Label>
                              <Input type="date" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Period of Training</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Advance Leave Days</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Bonus</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Gratuity</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Arrears if any</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Notice Pay</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>No of Days</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Gross Salary</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Grand Total of Earnings</Label>
                              <Input type="text" />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <h5 className="bg-light p-2">SETTLEMENT DEDUCTIONS DETAILS</h5>
                            <FormGroup>
                              <Label>Leave Excess Availed</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Gross Salary</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>PF Employer Contribution</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Notice Pay</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>No of Days</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Gross Salary</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Grand Total of Deductions</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Salary paid through payroll for the relieving month</Label>
                              <div>
                                <Input type="radio" name="salary" value="yes" /> Yes
                                <Input type="radio" name="salary" value="no" className="ms-2" defaultChecked /> No
                              </div>
                            </FormGroup>
                            <FormGroup>
                              <Label>Settlement amount payable to the employee</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Settlement amount payable by the employee</Label>
                              <Input type="text" />
                            </FormGroup>
                            <FormGroup>
                              <Label>Gratuity amount payable to the employee by Cheque</Label>
                              <Input type="text" />
                            </FormGroup>
                          </Col>
                        </Row>
                        <div className="text-end mt-3">
                          <Button type="submit" className="btn button-save me-2">
                            <i className="fas fa-save me-1" /> Save
                          </Button>
                          <Button color="secondary" onClick={() => setShowForm(false)} className="btn button-cancel" >
                            <i className="fas fa-sync me-1" /> Cancel
                          </Button>
                        </div>
                      </div>
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SettlementTable;
